<template>
    <div>
        <template v-if="resultsloaded">

        <div class="qmajorheader qmediumboldfont qalignleft" v-if="header">{{   langConv('Injuries and Suspensions') }}</div>    
                                
        <div class="grid-x text-center qsmallfont"  v-for="(re,i) in results" :key="i">

            <template v-if="i==0">
                <div class="cell small-4 qsmallfontbold"  >{{langConv('Player')}}</div>
                <div class="cell small-3 qsmallfontbold" >{{langConv('Reason')}}</div>
                <div class="cell small-2 qsmallfontbold" >{{langConv('Return')}}</div>
                <div class="cell small-2 qsmallfontbold" >{{ langConv('Updated') }}</div>

            </template> 


         
            <template> 
                <div class="cell small-4"  >{{re.PlayerName}}</div>
                <div class="cell small-3 qsmallfont" >{{re.Reason.replace(/_/g, ' ')}}</div>
                <div class="cell small-2 qsmallfont" >{{ $displayDate(re.ReturnDate,$dateformattype.daymonthshort) }}</div>
                <div class="cell small-2 qsmallfont" >{{ $displayDate(re.ModDate,$dateformattype.daymonthshort) }}</div>
            </template>   

        </div>


        <div class="cell" style="height:14px"></div>

        </template>
    </div>
</template>


<script>

    //import axios from 'axios';

    export default {
        name: "injuries",
        data: function data() {
                return {
                
                    resultsloaded: false
                }
        },
        props: {
       
            teamid: {type: Number, default: 0 },
            noitems: {type: Number, default: 10},
            header: {type: Boolean, default: false}
   
        },
        created() {

            this.loadInjuries();

        },
        methods: {


            loadInjuries: function () {

                this.resultsloaded = false

                let url = process.env.VUE_APP_WEBAPI  + "FeatureTables.svc/RetrieveGenericGet";
                let spname = "Injuries_NS";
                let Params = '[{ "Name": "@teamid", "Value": "' +  this.teamid + '"},{ "Name": "@noitems", "Value": "' +  this.noitems + '"}]';
  
                //get bet results for that bet
                this.newgenericresultset(url, Params,spname).then(response => { 
                  
                   this.results = response
                   this.resultsloaded = true;

                },
                        (error) => { console.log(error) }
                );


                }

            },

        }
   
</script>

<style lang="scss" scoped>

</style>